import React, {useEffect, useState} from "react";
import {objectAPI, photoAPI, reportsAPI} from '../../API/API'
import {Select, Image, Collapse, Button} from 'antd';
import moment from 'moment'
import s from '../photo/styles/photoArchive.module.css'
const {Panel} = Collapse;


const PhotoArchive = () => {

    const [objects, setObjects] = useState([])
    const [error, setError] = useState('')
    const [data, setData] = useState({})
    const [id, setId] = useState(0)
    const getPhotoZip = (id,start,stop) => {
        // download photo function
        window.open(`https://gdapp.org/API/2.0/downloads/getPhotoZip.php?id=${id}&start=${start}&end=${stop}`);
    }
    useEffect(() => {
        setError('')
        objectAPI.getObjects()
            .then(response => setObjects(response.data.objects.map(object => {
                return {value: object.id, label: `${object.name} | ${object.long_name}`, key: object.id}
            })))
            .catch(error => setError(error.message))
    }, [])


    const setImageArray = (links) => {

        const getDate = timestamp => {
            const getYear = timestamp => +moment(Number(timestamp) * 1000).format('YYYY')
            const getMonth = timestamp => +moment(Number(timestamp) * 1000).format('MM')
            const getDay = timestamp => +moment(Number(timestamp) * 1000).format('DD')
            const startMonth = +moment(Number(timestamp) * 1000).startOf('month').format('X')
            const endMonth = +moment(Number(timestamp) * 1000).endOf('month').format('X')
            return {year: getYear(timestamp), month: getMonth(timestamp), day: getDay(timestamp), start: startMonth, end: endMonth}
        }
        console.log(links)

        let resultArray = {}
        for (let link of links) {

            let date = getDate(link.upload_time)

            if (!(date.year in resultArray)) {
                resultArray[date.year] = {}
            }
            if (!(date.month in resultArray[date.year])) {
                resultArray[date.year][date.month] = {}
            }
            if (!(date.day in resultArray[date.year][date.month])) {
                resultArray[date.year][date.month][date.day] = []
            }
            resultArray[date.year][date.month][date.day].push({link: link.link})
        }

        setData(resultArray)


    }
    let result = []

    const setResult = (year) => {
        const setMonth = (month) => {
            const setDay = (day) => {

                let temp = []
                console.log(data)
                for (let i = 0, len = data[year][month][day].length; i < len;i++) {
                    temp.push({link: data[year][month][day][i].link, day: day})
                }
                console.log(temp)
                return temp

            }
            let dayResult = []
            for (let day in data[year][month]) {
                dayResult.push(setDay(day))
            }
            let r = dayResult.map((link) => {
                let res = []
                const Im = (props) => {
                    return(
                        <><Image
                            alt="111"
                            width={200}
                            src={`http://gdapp.org/data/${link[props.id].link}`}
                            fallback="data:image/png;base64,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"

                        />  <span className={s.textOverImg}>{`${link[props.id].day}.${moment(month).format('MM')}.${year}`}</span></>
                    )
                }
                for (let i = 0, len = link.length; i < len; i++){
                    res.push(<Im id={i} link={link[i]} />)
                }
                return res
            })

            const startMonth = moment(+dayResult[0][0].link?.slice(0,10)*1000).startOf('month').format('X')
            const endMonth = moment(+dayResult[0][0].link?.slice(0,10)*1000).endOf('month').format('X')
            console.log(moment(startMonth*1000).format('MMMM'))
            return(

                <Panel header={moment(startMonth*1000).format('MMMM')}  key={month}>
                    <Image.PreviewGroup>
                        {r}
                    </Image.PreviewGroup>
                    <div className={s.download__cont}>
                        <Button type="primary" onClick={()=>{getPhotoZip(id,startMonth,endMonth)}}>Скачать фото (архив ZIP)</Button>
                    </div>

                </Panel>

            )
        }
        let result2 = []
        for (let month in data[year]) {
            result2.push(setMonth(month))
        }

        return(

                <Panel header={year} key={year}>
                    <Collapse accordion bordered={false}>
                    {result2}
                    </Collapse>
                </Panel>

        )
    }

    for (let year in data) {
        result.push(setResult(year))
    }



    const getPhoto = (id) => {
        reportsAPI.getLinksById(id)
            .then(response => setImageArray(response.data.links))
            .catch(error => setError(error.message))
    }
    const onChange = (value) => {
        setId(value)
        getPhoto(value)
    };

    return (
        <>
            <div className={s.object__select}>
                <Select
                    style={{ width: '60%' }}
                showSearch
                placeholder="Выберите объект"
                optionFilterProp="children"
                onChange={onChange}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={objects}
            /></div>

            <Collapse accordion>
                {result}
            </Collapse>

            {error && <p>{error}</p>}
        </>

    )
}

export default PhotoArchive